module.exports = __webpack_public_path__ + "static/media/pic2.6ac0f40e.webp";